<horizon-menubar hostAppName="Court Booking" [items]="items()" [clubId]="coreFacade.selectedClubSignal()?.id"
                 [userName]="userName()" (clubIdChange)="coreFacade.selectedClubChanged($event)"
                 (logout)="handleLogout()"></horizon-menubar>
